<script setup lang="ts">
import type {ObjectSchema, ObjectValue, Schema, SchemaValue} from '@/generated-report/interfaces';
import FormField from "@/generated-report/components/form-schema/FormField.vue";
import FieldDescription from "@/generated-report/components/form-schema/fields/FieldDescription.vue";

const {schema, nestingLevel = 1} = defineProps<{
    schema: ObjectSchema;
    nestingLevel?: number;
}>();

const value = defineModel<ObjectValue>({required: true});

/**
 *
 * @param key
 * @param newValue
 */
const updateProperty = (key: string, newValue: SchemaValue) => {
    value.value = {
        ...value.value,
        [key]: newValue
    };
};

const getPropertyValue = (key: string) => {
    return value.value ? value.value[key] : undefined;
};
</script>

<template>
  <div
    class="space-y-4"
    :class="{
      'pl-4 border-l-2 border-primary space-y-6': nestingLevel > 1
    }"
  >
    <div>
      <FieldDescription v-if="schema.description?.length" :nesting-level="nestingLevel">
        {{ schema.description }}
      </FieldDescription>
    </div>
    <div class="space-y-8">
      <div
        v-for="(fieldSchema, key) in schema.properties"
        :key="key"
      >
        <FormField
          :model-value="getPropertyValue(key)"
          :schema="fieldSchema as Schema"
          :nesting-level="nestingLevel + 1"
          @update:model-value="updateProperty(key, $event)"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
